export const ACTIVITY_WAY = [
  {
    label: "活动",
    value: "4",
  },
  {
    label: "赛事",
    value: "1",
  },
  {
    label: "社区服务",
    value: "5",
  },
  {
    label: "培训",
    value: "3",
  },
  {
    label: "党建",
    value: "2",
  },
  {
    label: "资讯",
    value: "6",
  },
];

export const EditorToolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ align: [] }],
  [{ color: [] }, { background: [] }],
  ["link", "image", "video"],
  ["clean"], // remove formatting button
];

export const EditorToolbarOptions2 = [
  ["bold", "underline", "italic"], // toggled buttons "strike",
  // ["blockquote", "code-block"],
  // [{ header: 1 }, { header: 2 }], // custom button values
  // [{ list: "ordered" }, { list: "bullet" }],
  // [{ script: "sub" }, { script: "super" }], // superscript/subscript
  // [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ align: [] }],
  // ["link", "image", "video"],
  // ["clean"], // remove formatting button
];
